import React, { useState, useContext,useEffect } from "react";
import "../css/TopNavbar.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars, faBell, faHeadset, faCircleUser } from "@fortawesome/free-solid-svg-icons";
import { NewContext } from "../utils/ContextProvider";
import ModalConTabla from "../components/ModalConTabla.jsx";

function TopNavbar() {
  const {
    getCompany,
    getRol,
    setFlag,
    flag,
    presente,
    contador,
    selectedEmployee,
    profileImage,
    setProfileImage,
  } = useContext(NewContext);

  const [modalAbierto, setModalAbierto] = useState(false);
  const ulrPicturePersonal = "https://www.softnik.cloud/awsProfile/getProfile";

  const handleCampanaClick = async () => {
    setModalAbierto(true);
  };

  const handleSupportClick = () => {
    const phoneNumber = "+5492234550356";
    const message = "Hola, estoy utilizando la aplicación para control de presentismo y necesito soporte. ¿Podrían ayudarme, por favor?";
    const whatsappUrl = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, "_blank");
  };

  useEffect(() => {
    if (selectedEmployee && !profileImage) {
      const imageUrl = `${ulrPicturePersonal}?uuid=${selectedEmployee.id}&company=${getCompany}`;
      const img = new Image();
      img.src = imageUrl;
      img.onload = () => {
        setProfileImage(imageUrl); // Podés hacer un fetch y guardar base64 si querés evitar nuevas llamadas
      };
    }
  }, [selectedEmployee, profileImage, getCompany]);


  return (
    <div className="navbar-inner">
      <div className="img-mobile">
        <img
          src={require("../image/Logo-softnik-positivo.png")}
          alt="Logo-softnik"
        />
      </div>

      <div className="container-button-user">
        {getRol !== "ROLE_USER" && (
          <div>
            <FontAwesomeIcon
              icon={faBell}
              style={{
                color: "#2A9AB6",
                cursor: "pointer",
                fontSize: "22px",
                marginLeft: "20%",
              }}
              onClick={handleCampanaClick}
            />
            <div>
              {contador > 0 && presente && Object.keys(presente).length > 0 && (
                <span className="alert-contador" id="contador">
                  {contador}
                </span>
              )}
            </div>
            <ModalConTabla
              show={modalAbierto}
              handleClose={() => setModalAbierto(false)}
              data={presente ? presente.content : []}
            />
          </div>
        )}

        <div>
          <FontAwesomeIcon
            icon={faHeadset}
            style={{
              color: "#2A9AB6",
              cursor: "pointer",
              fontSize: "22px",
              marginLeft: "20%",
            }}
            onClick={handleSupportClick}
          />
        </div>
        <div>
          <FontAwesomeIcon
            icon={faBars}
            className="icon-menu-topbar"
            onClick={() => setFlag(!flag)}
          />
          <div className="avatar-container" style={{ position: "relative", width: "3rem", height: "3rem", marginRight: "18px" }}>
            <FontAwesomeIcon
              icon={faCircleUser}
              className="fa-user-icon"
              style={{
                position: "absolute",
                top: 8,
                left: 0,
                width: "2rem",
                height: "2rem",
                fontSize: "32px",
                color: "#2A9AB6",
              }}
            />

            {selectedEmployee && (
              <img
                src={profileImage}
                alt={`${getCompany}`}
                className="img-company"
                style={{
                  width: "2.5rem",
                  height: "2.5rem",
                  borderRadius: "100px",
                  objectFit: "cover",
                  position: "absolute",
                  top: 4,
                  left: 0,
                  display: "none",
                }}
                onLoad={(e) => {
                  e.target.style.display = "block";
                  const icon = e.target.previousSibling;
                  if (icon) icon.style.display = "none";
                }}
              />
            )}
          </div>

        </div>
      </div>
    </div>
  );
}

export default TopNavbar;
